/**
 * Support Service
 *
 * API functions for support ticket operations.
 */

import { apiClient } from "./api";
import type {
  AddMessageRequest,
  CreateTicketRequest,
  PaginatedTicketResponse,
  SupportTicketDetail,
  SupportTicketMessage,
} from "../types/support";

/**
 * Create a new support ticket
 */
export async function createTicket(
  request: CreateTicketRequest
): Promise<SupportTicketDetail> {
  const response = await apiClient.post<SupportTicketDetail>(
    "/api/v1/support/tickets",
    request
  );
  return response.data;
}

/**
 * Get the current user's support tickets
 */
export async function getTickets(
  page = 1,
  pageSize = 20
): Promise<PaginatedTicketResponse> {
  const response = await apiClient.get<PaginatedTicketResponse>(
    "/api/v1/support/tickets",
    {
      params: { page, page_size: pageSize },
    }
  );
  return response.data;
}

/**
 * Get a specific ticket by ID with messages
 */
export async function getTicket(
  ticketId: string
): Promise<SupportTicketDetail> {
  const response = await apiClient.get<SupportTicketDetail>(
    `/api/v1/support/tickets/${ticketId}`
  );
  return response.data;
}

/**
 * Add a reply message to a ticket
 */
export async function addMessage(
  ticketId: string,
  request: AddMessageRequest
): Promise<SupportTicketMessage> {
  const response = await apiClient.post<SupportTicketMessage>(
    `/api/v1/support/tickets/${ticketId}/messages`,
    request
  );
  return response.data;
}
